import {applyMiddleware, createStore, Middleware, Store} from "redux";
import thunk from "redux-thunk";
import {composeWithDevTools} from "redux-devtools-extension";

import rootReducer from "redux/reducers/rootReducer";

export interface ApplicationState {
    // Add redux states here that are imported from the reducers
}

const middleware: Array<Middleware> = [
    thunk,
];

export default function configureStore(): Store<ApplicationState> {
    return createStore(rootReducer, {}, composeWithDevTools(
        applyMiddleware(...middleware))
    );
}

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
